import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCalendar, FiClock, FiDownload } = FiIcons;

const CTA = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section id="contact" className="py-20 bg-azure-600 w-full" ref={ref}>
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
          transition={{ duration: 0.8 }}
          className="max-w-4xl mx-auto text-center"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-8">
            Bereit für die digitale Transformation?
          </h2>
          <p className="text-xl text-azure-100 mb-12 leading-relaxed">
            Lass uns in einem kostenlosen 15-minütigen Beratungsgespräch herausfinden, 
            wie KI-Automatisierung deine Kundenkommunikation revolutionieren kann.
          </p>

          <div className="grid md:grid-cols-2 gap-8 mb-12">
            {/* Beratungsgespräch */}
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={isInView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.9 }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="bg-white rounded-xl p-8 shadow-2xl"
            >
              <div className="flex items-center justify-center mb-4">
                <SafeIcon icon={FiCalendar} className="text-3xl text-azure-600 mr-3" />
                <h3 className="text-2xl font-semibold text-black">Kostenloses Erstgespräch</h3>
              </div>
              <div className="flex items-center justify-center mb-6 text-gray-600">
                <SafeIcon icon={FiClock} className="text-lg mr-2" />
                <span>15 Minuten • Unverbindliche KI-Beratung</span>
              </div>
              <a
                href="https://cal.meetergo.com/mike-trepte/15-min-telefonat-kostenfrei"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-azure-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-azure-700 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl w-full"
              >
                Jetzt Termin buchen
              </a>
            </motion.div>

            {/* Kostenloses Dokument */}
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={isInView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.9 }}
              transition={{ duration: 0.6, delay: 0.5 }}
              className="bg-white rounded-xl p-8 shadow-2xl"
            >
              <div className="flex items-center justify-center mb-4">
                <SafeIcon icon={FiDownload} className="text-3xl text-azure-600 mr-3" />
                <h3 className="text-2xl font-semibold text-black">Kostenloses KI-Guide</h3>
              </div>
              <div className="flex items-center justify-center mb-6 text-gray-600">
                <span>PDF-Leitfaden • KI für Ihr Unternehmen</span>
              </div>
              <Link
                to="/onboarding-form"
                className="inline-block bg-azure-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-azure-700 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl w-full"
              >
                Kostenlos herunterladen
              </Link>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTA;